import { supabase } from "@/integrations/supabase/client";
import type { LibrarySearchResult, LibrarySourceType } from "./types";

export const searchLibrarySources = async (query: string, sourceType?: LibrarySourceType) => {
  const trimmed = query.trim();
  if (trimmed.length < 2) return [] as LibrarySearchResult[];

  const { data, error } = await supabase.functions.invoke("source-metadata-search", {
    body: { query: trimmed, source_type: sourceType },
  });

  if (error) throw error;
  return ((data?.results as LibrarySearchResult[] | undefined) ?? []).map((item) => ({
    ...item,
    sourceType: item.sourceType ?? "book",
    metadata: item.metadata ?? {},
    status: item.status ?? "to_read",
    isOwned: item.isOwned ?? false,
    doi: item.doi ?? null,
    url: item.url ?? null,
    openAccessUrl: item.openAccessUrl ?? null,
    containerTitle: item.containerTitle ?? null,
    accessedDate: item.accessedDate ?? null,
    citationStyleOverride: item.citationStyleOverride ?? null,
    coverCandidates: item.coverCandidates ?? (item.coverUrl ? [item.coverUrl] : []),
    completeness: item.completeness ?? {
      hasIsbn: !!(item.isbn13 || item.isbn10),
      hasCover: !!item.coverUrl,
      hasPublisher: !!item.publisher,
      hasPageCount: !!item.pageCount,
      hasDescription: !!item.description,
    },
  }));
};
